import { VictoryAxis, VictoryBar, VictoryChart, VictoryLabel, VictoryLine, VictoryScatter, VictoryTheme } from 'victory';
import { InterestRateTable } from '../../../types/Projections';
import { colors } from '../../expirations/charts/utils/colors';
import { Col, Container, Row } from 'react-bootstrap';
import { UseChartWidth } from '../../expirations/charts/utils/UseChartWidth';


interface Props {
    interestRate : InterestRateTable[];
}

export const InterestRateGraph = ({interestRate} : Props) => {
    
    const width = UseChartWidth();

    const formatLabel = (value : any ) => {
        return `${value}`;
    }

    const leliq = interestRate.map((item) => {
        return {
            x: item.period,
            y: item.leliq
        }
    })

    const badlar = interestRate.map((item) => {
        return {
            x: item.period,
            y: item.badlar
        }
    })

    const maxValue =() =>{
        const leliqMax = Math.max(...leliq.map((d) => d.y ?? 0));
        const badlarMax = Math.max(...badlar.map((d) => d.y ?? 0));
        return Math.max(leliqMax, badlarMax);
    }

    const maxDomain = maxValue() + 10;

return (
    <Container>
        <Row>
            <Col>
                <VictoryChart
                        width={width}
                        padding={{
                            top: 20,
                            bottom: 80,
                            left: 65,
                            right: 20,
                        }}
                        domainPadding={[20, 20]}
                        theme={{
                            ...VictoryTheme.material,
                        }}
                        minDomain={{ y: 0 }}
                        maxDomain={{ y: maxDomain }}
                    >

                        <VictoryAxis
                            style={{
                                tickLabels: { angle: -45 },
                                ticks: {
                                stroke: 'transparent',
                                padding: 0,
                                },
                                axis: { stroke: colors.blueishGrey},
                                grid: { stroke: 'transparent' },
                            }}
                            tickLabelComponent={<VictoryLabel dy={-10} dx={-15}/>}
                        />

                        <VictoryAxis
                            dependentAxis
                            style={{
                                ticks: { stroke: 'transparent' },
                                grid: {
                                stroke: colors.extraLightGrey,
                                strokeWidth: 3,
                                strokeDasharray: 0,
                                },
                                axis: { stroke: colors.blueishGrey, strokeWidth: 3 },
                            }}
                            tickFormat={formatLabel}
                        />


                         <VictoryScatter
                            data={leliq}
                            style={{data: {fill: colors.darkBlue}}}
                            size={width/100}
                        />
                        <VictoryScatter
                            data={badlar}
                            style={{data: {fill: colors.lightBlue}}}
                            size={width/100}
                        />

                    </VictoryChart>
            </Col>
        </Row>
            <Row className="justify-content-center align-items-center">
                <Col xs="auto">
                    <div className="d-flex flex-column align-items-center">
                    <div className="mr-2" style={{ width: 15, height: 15, borderRadius: 8, backgroundColor: colors.lightBlue, marginBottom: 5 }} />
                    <span style={{ fontSize: 12 }}>BADLAR</span>
                    </div>
                </Col>
                <Col xs="auto">
                    <div className="d-flex flex-column align-items-center">
                    <div className="mr-2" style={{ width: 15, height: 15, borderRadius: 8, backgroundColor: colors.darkBlue, marginBottom: 5 }} />
                    <span style={{ fontSize: 12 }}>Leliq</span>
                    </div>
                </Col>
            </Row>
    </Container>
)
}
